import {Avatar, AvatarBackground, AvatarLanguage, AvatarVoiceAvatar} from "@/store/AIAvatar/aiavatarGenerationModel";

export class Slide{
  public documentName:string='';
  public documentType:string='PDF';

  // Video description
  public videoQuality:string='';
  public soundQuality:string='';
  public videoSrt:string='';
  public videoTitle:string='';
  public videoDescription:string='';
  public fileID:string="";
  public chunkVideoUrl:string="";
  public videoTimestampStart:number=0;
  public videoTimestampEnd:number=0;

  // PDF description
  public documentPage:number=0;
  public originalDocumentB64:string="";
  public order:number=0;
  public text="";

  // Avatar setup
  public avatarBackground: AvatarBackground|null=null
  public avatar:Avatar|null=null;
  public lang:AvatarLanguage|null=null;
  public voice:AvatarVoiceAvatar|null=null;

  // Slide HTML
  public slideTemplate:string=SlideTemplate.AVATAR_LEFT;
  public slideTitle:string="";
  public slideDescription:string="";
  public slideTheme: string="";
  public promptIllustrationGeneration: string="";
  public slideImageB64:string="";
  public slideVideoUrl:string="";
  public script="";
  public layout: ScriptSlideLayout=ScriptSlideLayout.AVATAR_BOTTOM_LEFT;
  public exportStaticB64:string="";

}

export enum ScriptSlideLayout{
  AVATAR_ONLY="AVATAR_ONLY",
  AVATAR_BOTTOM_LEFT="AVATAR_BOTTOM_LEFT",
  VOICE_ONLY="VOICE_ONLY",
  SLIDE="SLIDE"
}


export enum SlideTemplate{
  AVATAR_LEFT="AVATAR_LEFT",
  AVATAR_RIGHT="AVATAR_RIGHT",
  TITLE="TITLE",
  TITLE_ILLUSTRATED='TITLE_ILLUSTRATED',
  ILLUSTRATED_LEFT="ILLUSTRATED_LEFT",
  ILLUSTRATED_RIGHT="ILLUSTRATED_RIGHT",
  ILLUSTRATED_ONLY="ILLUSTRATED_ONLY",
  NONE="NONE",
}

export enum SlideGenerationMode{
  ENHANCED="ENHANCED",
  STRICT="STRICT",
  NONE="NONE",
}
